import styled from "styled-components/macro";

/* NOTE: min-height:
   http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox */
export const TabsWrapper = styled.div`
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  flex-grow: 1;
  max-width: 100%;
  min-height: 0;
  font-size: 0.875rem;
`;

export const TabsPaneWrapper = styled.div`
  background-color: #dddddd;
  display: block;
  padding: 1rem 1rem 1rem 0;
  // border: 1px solid;
  // border-radius: 5px;
  // border-top-left-radius: 0px;
  // border-top-right-radius: 0px;
  // border-color: #bdc3c7;
  // border-top: none;
  height: 100%;
  overflow-y: auto;
`;

/* NOTE: min-height:
   http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox */
export const TabPane = styled.div`
  min-height: 0;
`;

export const NavLink = styled.span<{ isSelected: boolean }>`
  cursor: pointer;
  background-color: ${props => (props.isSelected ? "#dddddd" : "#cecece")};
  border: 1px solid #bdc3c7;
  user-select: none;
  margin-right: 0.125rem;
  // border-bottom: none;
  position: relative;
  z-index: 0;
`;

export const NavWrapper = styled.div`
  position: relative;

  &:after,
  &:before {
    position: absolute;
    content: "";
    width: 100%;
    bottom: 0;
    left: 0;
    border-bottom: 1px solid #bdc3c7;
    z-index: 1;
  }

  .nav-tabs .nav-link {
    border: 1px solid;
    border-color: #bdc3c7;
    // border-bottom: none;
  }

  .nav-tabs .nav-link.active {
    color: rgba(29, 29, 29);
    border-color: #bdc3c7 #bdc3c7 transparent #bdc3c7;
    z-index: 2;
    border-bottom-color: #dddddd;
    background-color: #dddddd;
  }

  .nav-tabs .nav-link.active:hover {
    border-color: #bdc3c7 #bdc3c7 transparent #bdc3c7;
  }

  .nav-tabs .nav-link:focus,
  .nav-tabs .nav-link:hover {
    border-color: #cccccc;
  }
`;

export const NavItem = styled.li`
  &:first-child ${NavLink} {
  }
`;

export const WorklistDataWrapper = styled.div`
  margin-top: 1em;
`;
